import { render } from "./UserActivitySection.vue?vue&type=template&id=dce6c91e&scoped=true"
import script from "./UserActivitySection.vue?vue&type=script&lang=js"
export * from "./UserActivitySection.vue?vue&type=script&lang=js"

import "./UserActivitySection.vue?vue&type=style&index=0&id=dce6c91e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce6c91e"]])

export default __exports__